import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { F0Alert, F0Box } from '@factorialco/f0-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { SurveysDataCollection } from './dataCollection'
import { useSurveyOne } from './one'

export default function SurveysListPage() {
  const [canCreateSurvey, setCanCreateSurvey] = useState(false)
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { handleCreateSurvey } = useSurveyOne({ canCreateSurvey })

  return (
    <ResponsivePage.Body variant="standard">
      <F0Box marginBottom="lg" maxWidth="screen-md">
        <F0Alert
          variant="info"
          title={i18n.t('surveys.overview.workflow_surveys_moved_banner.title')}
          description={i18n.t('surveys.overview.workflow_surveys_moved_banner.description')}
          action={{
            label: i18n.t('surveys.overview.workflow_surveys_moved_banner.action'),
            onClick: () => navigate(navigation.processes.surveys.fullPath()),
          }}
        />
      </F0Box>
      <SurveysDataCollection
        handleCreateSurvey={handleCreateSurvey}
        onCanCreateSurveyChange={setCanCreateSurvey}
      />
    </ResponsivePage.Body>
  )
}
